<template>
  <div class="floating-card" v-if="hideBackdrop">
    <slot></slot>
  </div>
  <div class="floating-card-wrapper" v-else>
    <div class="backdrop" @click.self="close"></div>
    <div class="floating-card">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close() {
      this.$emit("close");
    },
  },
  emits: ["close"],
  props: ["hide-backdrop"],
};
</script>
<style scoped>
.floating-card-wrapper {
  z-index: 2;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.backdrop {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 1;
}

.floating-card {
  position: sticky;
  height: fit-content;
  max-width: 70vw;
  max-height: 70vh;
  left: 0;
  border-radius: 8px;
  filter: drop-shadow(0px 2px 2px var(--shadow));
  margin: auto;
  z-index: 2;
  background-color: var(--backgroundColor);
  padding: 40px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
